import { Routes, Route, Navigate } from "react-router";
import { useAuth } from "../context/AuthContext";
import PrivateRoutes from "./PrivateRoute";
import App from "../App";
import Dashboard from "../pages/Dashboard";
import Employees from "../pages/Employees";
import NewEmployee from "../pages/NewEmployee";
import EmployeeDetail from "../pages/EmployeeDetail";
import Tablets from "../pages/Tablets";
import NewTablet from "../pages/NewTablet";
import TabletDetail from "../pages/TabletDetail";
import PanelUsers from "../pages/PanelUsers";
import NewPanelUser from "../pages/NewPanelUser";
import Settings from "../pages/Settings";
import GeneralSettings from "../pages/GeneralSettings";
import DepartmentSettings from "../pages/DepartmentSettings";
import NewDepartment from "../pages/NewDepartment";
import TagSettings from "../pages/TagSettings";
import NewTag from "../pages/NewTag";
import UpdateTag from "../pages/UpdateTag";
import ContractSettings from "../pages/ContractSettings";
import NewContract from "../pages/NewContract";
import PublicRoutes from "./PublicRoute";
import LoginPage from "../pages/LoginPage";
import Calendar from "../pages/Calendar";
import Applicants from "../pages/Applicants";
import NewApplicant from "../pages/NewApplicant";
import EmployeeUpdatePage from "../components/Employees/EmployeesUpdateForm";
import PanelUserUpdatePage from "../components/PanelUsers/PanelUsersUpdateForm";
import DocumentUploadPage from "../components/EmployeeDetail/DocumentUploadModal";
import WorkPermitCreatePage from "../components/EmployeeDetail/WorkPermitsCreateModal";
import UpdateDepartment from "../components/Settings/Department/DepartmentUpdateForm";
import UpdateContract from "../components/Settings/Contract/ContractUpdateForm";
import TerminalUpdatePage from "../components/Tablets/TerminalUpdateForm";
import ShiftNewPage from "../components/Calendar/ShiftNewPage";
import ShiftEditPage from "../components/Calendar/ShiftEditPage";
import MonthlyReport from "../pages/MonthlyReport";
import EntryExitReport from "../pages/EntryExitReport";
import CorrectionRequests from "../pages/CorrectionRequests";
import Shifts from "../pages/Shifts";
import ShiftAssignment from "../pages/ShiftAssignment";
import ShiftTeams from "../pages/ShiftTeams";
import ShiftRotations from "../pages/ShiftRotations";
import ShiftRotationDetail from "../pages/ShiftRotationDetail";
import RotationBoard from "../pages/RotationBoard";
import WorkShiftSettings from "../pages/WorkShiftSettings";
import NewWorkShift from "../pages/NewWorkShift";
import Reports from "../pages/Reports";
import WorkShiftDetail from "../pages/WorkShiftDetail";
import AdminRoute from "./AdminRoute";
import NotFound from "../pages/NotFound";



export default function AppRoutes() {
  const { company } = useAuth();

  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path="/" element={<App />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} index />
          {company?.modules?.isCalendarAvailable && (
            <Route path="calendar">
              <Route index element={<Calendar />} />
              <Route path="shifts/new" element={<ShiftNewPage />} />
              <Route path="shifts/edit/:id" element={<ShiftEditPage />} />
            </Route>
          )}

          <Route path="employees">
            <Route index element={<Employees />} />
            <Route path="new" element={<NewEmployee />} />
            <Route path=":id" element={<EmployeeDetail />} />
            <Route path=":id/edit" element={<EmployeeUpdatePage />} />
            {/*
              `:id/documents` ve `:id/work-permits` KALDIRILDI. İkisi de
              `/employees/:id` sekmelerinin (Özlük Belgeleri / İzinler) ikinci
              bir mount'uydu ve hiçbir yerden linklenmiyordu.
              - documents: `DocumentsTable` propla beslenen bir sunum bileşeni;
                rota onu propsuz mount ettiği için sayfa HER ZAMAN boştu.
              - work-permits: veriyi kendi çekiyordu ama `Container` dışında
                kaldığı için dolgusuzdu ve hangi personele ait olduğu hiçbir
                yerde yazmıyordu.
              Yükleme/ekleme sayfaları zaten sekmeye dönüyor (`state.tab`).
            */}
            <Route path=":id/documents/upload" element={<DocumentUploadPage />} />
            <Route path=":id/work-permits/create" element={<WorkPermitCreatePage />} />
          </Route>

          <Route path="tablets">
            <Route index element={<Tablets />} />
            <Route path="new" element={<NewTablet />} />
            <Route path="/tablets/edit" element={<TerminalUpdatePage />} />
            {/* :id en sonda — react-router statik segmentleri (new/edit)
                dinamiklerin üstünde sıralar, yine de niyet açık dursun. */}
            <Route path=":id" element={<TabletDetail />} />
          </Route>
          {company?.modules?.isApplicantAvailable && (
            <Route path="human-resources" element={<Settings />}>
              {/* Reports/settings ile aynı tuzak: element yalnızca <Outlet/>,
                  index olmadan "İnsan Kaynakları" linki boş sayfaya düşüyordu. */}
              <Route index element={<Navigate to="cv-pool" replace />} />
              <Route path="cv-pool">
                <Route index element={<Applicants />} />
                <Route path="new" element={<NewApplicant />} />
              </Route>
            </Route>
          )}
          <Route element={<AdminRoute />}>
            <Route path="panel-users">
              <Route index element={<PanelUsers />} />
              <Route path="new" element={<NewPanelUser />} />
              <Route path=":id/edit" element={<PanelUserUpdatePage />} />
            </Route>
          </Route>
          <Route path="reports" element={<Reports />}>
            {/* Reports yalnızca <Outlet/>; index olmadan sidebar'daki "Raporlar"
                ve kırıntı yolundaki "Raporlar" linki boş sayfaya düşüyordu. */}
            <Route index element={<Navigate to="monthly-report" replace />} />
            <Route path="monthly-report" element={<MonthlyReport />} />
            <Route path="entry-exit-reports" element={<EntryExitReport />} />
            {/* Çalışan bildirimleri (plan 2.50) — kararı puantajı değiştirdiği
                için Raporlar altında. */}
            <Route path="correction-requests" element={<CorrectionRequests />} />
          </Route>
          {/* Vardiya tanımı + atama (plan 2.24). Takvim'den AYRI: orası işgücü
              planı, burası çalışma düzeni. */}
          <Route path="shifts" element={<Shifts />}>
            <Route index element={<Navigate to="work-shift" replace />} />
            <Route path="shift-assignment" element={<ShiftAssignment />} />
            <Route path="work-shift">
              <Route index element={<WorkShiftSettings />} />
              <Route path="new" element={<NewWorkShift />} />
              <Route path=":id" element={<WorkShiftDetail />} />
            </Route>

            {/* Ekip + rota (plan 2.33/2.34). "Bu hafta kim nerede" BÜTÜN İK
                kullanıcılarına açık — rota hesaplanan bir şey ve onu görmek
                bakma işidir. Ekip/rota KURMA admin'e ait; backend zaten
                admin'e kilitli, buradaki AdminRoute menüyü ve sayfayı da
                gizliyor ki kullanıcı 403 duvarına toslamasın. */}
            <Route path="rotation-board" element={<RotationBoard />} />
            <Route element={<AdminRoute />}>
              <Route path="teams" element={<ShiftTeams />} />
              <Route path="rotations">
                <Route index element={<ShiftRotations />} />
                <Route path="new" element={<ShiftRotationDetail />} />
                <Route path=":id" element={<ShiftRotationDetail />} />
              </Route>
            </Route>
          </Route>

          <Route element={<AdminRoute />}>
            <Route path="settings" element={<Settings />}>
              {/* Sidebar'daki ilk alt başlık Genel Ayarlar; "Ayarlar" linki
                  index olmadığı için boş sayfaya düşüyordu. */}
              <Route index element={<Navigate to="general" replace />} />
              <Route path="general" element={<GeneralSettings />} />
              <Route path="department">
                <Route index element={<DepartmentSettings />} />
                <Route path="new" element={<NewDepartment />} />
                <Route path=":id/update" element={<UpdateDepartment />} />
              </Route>
              <Route path="tags">
                <Route index element={<TagSettings />} />
                <Route path="new" element={<NewTag />} />
                <Route path=":id/update" element={<UpdateTag />} />
              </Route>
              {/* Eski rol/yetenek rotaları tek etiket sayfasına yönlenir. */}
              <Route
                path="role"
                element={<Navigate to="/settings/tags?kind=role" replace />}
              />
              <Route
                path="skill"
                element={<Navigate to="/settings/tags?kind=skill" replace />}
              />
              <Route path="contract">
                <Route index element={<ContractSettings />} />
                <Route path="new" element={<NewContract />} />
                <Route path=":id/update" element={<UpdateContract />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
      <Route element={<PublicRoutes />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
    </Routes>
  );
}
